import React from 'react';

import { Separator, ShimmerComponent } from '@zydalabs/storefront-components';

const PaymentMethodsLoading = () => (
  <>
    <Separator my={0} mx={4} />
    <ShimmerComponent.ShimmerEffect>
      <ShimmerComponent.Rect height={20} width="30%" mt={4} mx={4} />
    </ShimmerComponent.ShimmerEffect>
    <ShimmerComponent.ShimmerEffect>
      <ShimmerComponent.NoAnimationBox py="12px" width={1} flexDirection="row" mx={2}>
        {Array.from([...Array(3)].keys()).map(number => (
          <React.Fragment key={number}>
            <ShimmerComponent.Rect height={66} width="50%" mt={2} mx={2} />
          </React.Fragment>
        ))}
      </ShimmerComponent.NoAnimationBox>
    </ShimmerComponent.ShimmerEffect>
  </>
);

export default PaymentMethodsLoading;
